import React, { Fragment } from "react";
import Icon from "./Icon";

const APIError = () => {
  return (
    <div className="u-center">
      <Icon name="circleExclamation" width={44} height={44} />
      <p
        className="f-h4 c-purple u-mt3 u-mb2"
        style={{ maxWidth: "410px", margin: "0 auto" }}
      >
        Our system has encountered an error, please try later or call{" "}
        <span className="f-nowrap">
          <a href="tel:18663167263">1-866-316-7263</a>.
        </span>
      </p>
    </div>
  );
};

export default APIError;
